import { DOC_PATH } from '@shared/api/paths';

export const MAIN_PATH = 'report';

export const path = `${DOC_PATH}/${MAIN_PATH}`;
